import { useState, useEffect } from 'react';

// Shared state/logic behind the capacity/surface/date/"Play Now" filters used on
// both the Explore page and an operator's public profile page.
export function useAvailabilityFilters() {
  const [filterCapacity, setFilterCapacity] = useState('all');
  const [filterSurface, setFilterSurface] = useState('all');
  const [filterDate, setFilterDate] = useState('');
  const [isRightNowActive, setIsRightNowActive] = useState(false);
  const [bookableOnly, setBookableOnly] = useState(false);
  const [debouncedFilterDate, setDebouncedFilterDate] = useState('');

  // Debounce the date filter so we don't hit the availability endpoint on every
  // keystroke; "Play Now" bypasses the debounce so it feels instant.
  useEffect(() => {
    if (isRightNowActive) {
      setDebouncedFilterDate(filterDate);
      return;
    }
    const timer = setTimeout(() => setDebouncedFilterDate(filterDate), 500);
    return () => clearTimeout(timer);
  }, [filterDate, isRightNowActive]);

  const handleDateChange = (value) => {
    setFilterDate(value);
    setIsRightNowActive(false);
  };

  const handleRightNowToggle = () => {
    if (isRightNowActive) {
      setIsRightNowActive(false);
      setFilterDate('');
      setBookableOnly(false);
    } else {
      const oneHourFromNow = new Date();
      oneHourFromNow.setHours(oneHourFromNow.getHours() + 1);
      // Adjust for local timezone offset so the input displays correctly
      oneHourFromNow.setMinutes(oneHourFromNow.getMinutes() - oneHourFromNow.getTimezoneOffset());
      setFilterDate(oneHourFromNow.toISOString().slice(0, 16));
      setIsRightNowActive(true);
      setBookableOnly(true);
    }
  };

  const resetFilters = () => {
    setFilterCapacity('all');
    setFilterSurface('all');
    setFilterDate('');
    setIsRightNowActive(false);
    setBookableOnly(false);
  };

  const hasActiveFilters =
    filterCapacity !== 'all' || filterSurface !== 'all' || filterDate !== '' || bookableOnly;

  return {
    filterCapacity, setFilterCapacity,
    filterSurface, setFilterSurface,
    filterDate, handleDateChange,
    debouncedFilterDate,
    isRightNowActive,
    bookableOnly, setBookableOnly,
    handleRightNowToggle,
    resetFilters,
    hasActiveFilters,
  };
}
